import Link from 'next/link'

import Chevron from '@/components/Icon/Chevron'
import { Translated } from '@/components/Translated'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { handleClick } from '@/utils/tracking/eventsHandlers'

import { navigationLink, navigationPanel } from './styles.css'

type Props = {
  currentIndex: number
  nextUrl: string
  previousUrl: string
  totalProperties: number
}

export const NearbyNavigation: React.FC<Props> = ({ currentIndex, nextUrl, previousUrl, totalProperties }) => {
  return (
    <div className={navigationPanel} data-testid="index-navigation">
      <Link passHref href={previousUrl}>
        <a
          className={navigationLink}
          data-testid="prev-nearby-button"
          onClick={() => {
            handleClick('NearPropertiesBanner', 'Previous')
          }}
        >
          <Chevron direction="left" />
        </a>
      </Link>
      <div data-testid="nearby-navigation-progress">
        <Translated
          i18Key="listing-detail:NearPropertiesBanner_PropertiesProgress"
          values={{ n: currentIndex + 1, tot: totalProperties }}
        />
      </div>
      <div
        className={sprinkles({
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          paddingX: 'm',
        })}
      >
        <Link href={nextUrl}>
          <a
            className={navigationLink}
            data-testid="next-nearby-button"
            onClick={() => {
              handleClick('NearPropertiesBanner', 'Next')
            }}
          >
            <Chevron direction="right" />
          </a>
        </Link>
      </div>
    </div>
  )
}
